export default __webpack_public_path__ + "static/powerup-dd050750f79790f5a4f1e12e601a77d2.gif";